import { render, staticRenderFns } from "./CheckoutForm.vue?vue&type=template&id=1d88cb72&"
import script from "./CheckoutForm.vue?vue&type=script&lang=js&"
export * from "./CheckoutForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutForm.vue?vue&type=style&index=0&id=1d88cb72&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports